<template>
  <div>
    <toggle-button v-model="config.amountView" :color="color" :labels="getLabels" :font-size="15" :width="220" :height="40" @change="emitConfig"/>
  </div>
</template>

<script>
import generalMethods from "@/mixins/insights/generalMethods";

export default {
  mixins: [generalMethods],
  name: "AmountViewToggle",
  props: ['editing', 'currentConfig'],
  components: {  },
  data() {
    return {
      color: { checked: '#00c9ff', unchecked: '#127a94' },
    }
  },
  computed: {
    getLabels() {
      return {checked: this.$t('insights.jobProgress.amount'), unchecked: this.$t('insights.jobProgress.time'), value: false};
    }
  },
  created() {
    this.config = this.currentConfig;
    if (this.config.amountView === null || this.config.amountView === undefined) {
      this.config.amountView = true;
      this.emitConfig();
    }
  }

}
</script>

<style>

.v-switch-core, .v-switch-button {
  border-radius: 0px !important;
}
.v-switch-button {
  background-color: unset !important;
  width: 30px !important;
}
.toggled > .v-switch-core > .v-switch-button::after {
  content: "\f468" !important;
  margin-right: 15px !important;
}
.v-switch-core > .v-switch-button::after {
  content: "\f017";
  margin-left: 5px;
}
.v-switch-button::after {
  font-family: "Font Awesome 5 Pro";
  font-weight: 400;
  font-size: 18px;
  color: white;
  line-height: 35px;
}
</style>